import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import JxIconButton from '../../../../../JxControls/JxButtons/JxIconButton';
import floatingPanelEngine from '../../Core/FloatingPanelEngine';
import useSearchResults from './useSearchResults';
import './SearchDrawerPager.css';

/**
 * SearchDrawerPager — found label left, prev/next pager right.
 * Always rendered when query >= 3 chars, pager buttons hidden when totalPages <= 1.
 *
 * @param {string} props.panelId
 * @param {number} props.total
 * @param {string} props.query
 */
export default function SearchDrawerPager({ panelId, total, query }) {
    const { page } = useSearchResults(panelId);
    const provider = floatingPanelEngine.getProvider(panelId);
    const pageSize = provider?.getPageSize() ?? 25;
    const totalPages = Math.ceil(total / pageSize) || 1;

    if (query?.length < 3) return null;

    return (
        <div className="sd-pager">
            <span className="sd-pager-found">{total} found</span>

            {totalPages > 1 && (
                <div className="sd-pager-nav">
                    <JxIconButton
                        icon={<ChevronLeftIcon sx={{ fontSize: 14 }} />}
                        disabled={page <= 1}
                        onClick={() => provider?.prevPage()}
                        title="Previous page"
                    />
                    <span className="sd-pager-label">
                        {page} / {totalPages}
                    </span>
                    <JxIconButton
                        icon={<ChevronRightIcon sx={{ fontSize: 14 }} />}
                        disabled={page >= totalPages}
                        onClick={() => provider?.nextPage()}
                        title="Next page"
                    />
                </div>
            )}
        </div>
    );
}
